import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DeviceDetectorService } from '@core/services';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@environment/environment';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-docflow',
  imports: [AsyncPipe, NgClass, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './docflow.component.html',
})
export class DocflowComponent {
  readonly deviceService = inject(DeviceDetectorService);
  private readonly domSanitizer = inject(DomSanitizer);

  readonly docflowIframeSrc: SafeResourceUrl =
    this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${environment.docflowIframeUrl}`,
    );
}
